module.exports = __webpack_public_path__ + "img/greenEvaluator.f73b25cc.svg";